import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import React, { useEffect, useState } from "react";
import { ITag } from "@/interfaces/ITag";
import { useTagService } from "@/services/useTagService";
import { toast } from "sonner";

interface iProps {
  open: boolean;
  setOpenChange: (open: boolean) => void;
  onCreated?: () => void;
  tagInitial: ITag | undefined;
}

const DialogMarkersEdit = ({
  open,
  setOpenChange,
  onCreated,
  tagInitial,
}: iProps) => {
  const [tag, setTag] = useState<ITag | undefined>(tagInitial);
  const { update, remove } = useTagService();
  const [updating, setUpdating] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const oldName = tagInitial?.name;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTag((prevTag) => ({
      ...prevTag,
      name: e.target.value,
    }));
  };

  const handleEdit = async () => {
    setUpdating(true);
    try {
      if (!tag?.id) {
        toast.error("impossible update a tag without ID");
        onCreated?.();
        return;
      }
      await update(tag?.id, tag);
      toast.success("Tag updated successfully!");
      setOpenChange(false);
      onCreated?.();
    } catch (error) {
      console.error("Erro to update tag:", error);
      toast.error("Erro to update tag. try again.");
    } finally {
      setUpdating(false);
    }
    onCreated?.();
  };
  const handleDelete = async () => {
    setTag((prevTag) => ({
      ...prevTag,
      name: "",
    }));
    setDeleting(true);
    try {
      const id = tag?.id;
      if (id) {
        await remove(id);
        toast.success("tag deleted successfully!");
        setOpenChange(false);
      }
    } catch (error: any) {
      toast.error("Error to update task");
      console.error(error);
    } finally {
      setDeleting(false);
    }
    onCreated?.();
  };
  useEffect(() => {
    if (tagInitial) {
      setTag({ ...tagInitial });
    }
  }, [tagInitial]);
  return (
    <Dialog open={open} onOpenChange={setOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader className="m-5">
          <DialogTitle>Edit markers</DialogTitle>
          <DialogDescription>Set a new name</DialogDescription>
          <p>Old name: {oldName}</p>
          <Input
            placeholder="Name marker"
            className="my-1"
            value={tag?.name}
            onChange={handleChange}
          />
          <div className="flex justify-between">
            <Button
              className="w-min"
              onClick={handleEdit}
              loading={updating}
              disabled={deleting}
            >
              Update
            </Button>
            <Button
              className="w-min"
              variant="destructive"
              onClick={handleDelete}
              loading={deleting}
              disabled={updating}
            >
              Remove
            </Button>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default DialogMarkersEdit;
